module.exports = __webpack_public_path__ + "static/media/background_grass.7ab1d648.svg";